import React from 'react';
import { BlockFactory } from '../../../../../global/components/block-factory';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { BaseBlockModel } from '../../../../../global/models/tcsm-block-models';

interface Props {
    guidesResourcesHeader: string;
    guidesResourcesBlocks: BaseBlockModel[];
}

export function PortalGuidesAndResources(props: Props) {
    const { guidesResourcesHeader, guidesResourcesBlocks } = props;

    return (
        <DividerSection removeDivider sectionText={guidesResourcesHeader}>
            <div className='dashboard-resources-container'>
                {
                    guidesResourcesBlocks?.map((x, i) => <BlockFactory key={x.blockType + i} blockData={x} />)
                }
            </div>
        </DividerSection>
    );
}